import {styled} from "@mui/material/styles"

export const SearchBannerChevronContainer = styled("div")(({theme}) => {
    return {
        gridArea: "end",
        paddingInlineEnd: "1rem",
        textAlign: "right",
        alignSelf: "inherit",
        minWidth: "2rem",
        [theme.breakpoints.up("md")]: {
            padding: "0.5rem",
            position: "relative",
            left: "0.5rem",
        },
    }
})
